/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import {dlsColor} from '@ion/dls/src/theme/theme';
import {DLSTheme} from '@ion/dls/src/types/types';

const sharedStyles = theme => ({
  dls: {
    motion: {
      element: {
        smallExpansion: {
          close: closeSmallExpansion,
          open: openSmallExpansion
        }
      }
    }
  },
  typography: {
    fontFamily
  }
}: DLSTheme): object => ({
  addressText : {
    color      : dlsColor('grey3'),
    margin     : '0',
    textAlign  : 'right',
    fontFamily : fontFamily
  },
  panelClosed : {
    transition : `transform ${closeSmallExpansion}`
  },
  panelOpen : {
    transform  : 'rotateZ(180deg)',
    transition : `transform ${openSmallExpansion}`
  }
});
export default sharedStyles;
